import { Scale, ClipboardCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FloatingActionButtons = ({ 
  weightLoggedToday, 
  checkinDue, 
  checkinCompleted 
}) => {
  const navigate = useNavigate();

  // Don't show if everything is completed
  const showWeightButton = !weightLoggedToday;
  const showCheckinButton = checkinDue && !checkinCompleted;
  
  if (!showWeightButton && !showCheckinButton) {
    return null;
  }

  return (
    <div className="fixed bottom-24 right-6 z-40 flex flex-col gap-3">
      {/* Check-in button (shows on Wed-Thu if not completed) */}
      {showCheckinButton && (
        <button
          onClick={() => navigate('/app/checkin')}
          className="group relative w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center animate-pulse-slow"
          aria-label="Complete weekly check-in"
        >
          <ClipboardCheck className="w-7 h-7 text-white" />
          
          {/* Tooltip */}
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Weekly check-in due
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-gray-900"></div>
          </div>
          
          {/* Notification badge */}
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white">
            !
          </span>
        </button>
      )}

      {/* Weight log button (shows if not logged today) */}
      {showWeightButton && (
        <button
          onClick={() => navigate('/app/weight-log')}
          className="group relative w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
          aria-label="Log today's weight"
        >
          <Scale className="w-7 h-7 text-white" />
          
          {/* Tooltip */}
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Log today's weight
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-gray-900"></div>
          </div>
          
          {/* Notification badge */}
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white">
            1
          </span>
        </button>
      )}
    </div>
  );
};

export default FloatingActionButtons;
